import React, { useMemo, useState } from 'react'
import moment from 'moment';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { MilestoneStep } from 'types/collaboration';
import {WheelPicker} from "../../../Common/calendar/WheelPicker";
import { submitStepDeadline } from 'services/api/collaboration';
import { RootState, store } from 'store';
import inModal from 'utils/hoc/inModal';
import { useSelector } from 'react-redux';

interface DeadlineCalendarProps {
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    step: MilestoneStep
}


const hourItems = Array.from({ length: 12 }, (_, index) => ({
    value: index + 1,
    label: index + 1
}));

const minuteItems = Array.from({ length: 4 }, (_, index) => ({
    value: `${(index * 15).toString().padStart(2, "0")}`,
    label: `${(index * 15).toString().padStart(2, "0")}`
}));

const ampmItems = [
    { value: "AM", label: "AM" },
    { value: "PM", label: "PM" }
];

const currentDaysInMonth = dayjs().daysInMonth();
const dateItems = Array.from({ length: 12 }, (_, i) => {
    const date = dayjs().add(i, "day");
    return {
        value: date.startOf("day").format("YYYY-MM-DD"),
        label: i === 0 ? "Today" : date.format("ddd DD MMM")
    };
});

const DeadlineCalendar: React.FC<DeadlineCalendarProps> = ({ step, onClose }) => {

    const selectedHubId = useSelector((state: RootState) => state.auth.selectedHubId);
    const [date, setDate] = useState(dateItems[0].value);
    const [hour, setHour] = useState(hourItems[0].value);
    const [minute, setMinute] = useState(minuteItems[2].value);
    const [ampm, setAmpm] = useState(ampmItems[0].value);

    const { campaignId, influencerId } = useParams();

    const getISOString = () => {
        const formattedDate = moment(`${date} ${hour}:${minute} ${ampm}`, "YYYY-MM-DD hh:mm A");
        return formattedDate.toISOString();
    };

    const submitDeadline = async () => {

        const dateTime = getISOString();

        if (!dateTime || !campaignId || !selectedHubId || !influencerId) return;
        try {
            const result = await submitStepDeadline(selectedHubId, campaignId, influencerId, step.gig_step.slug, dateTime)
            console.log(result);
            onClose(true);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className='w-100'>
            <div className='w-100 d-flex justify-content-center align-items-center text-dark date-time-wheel'>
                <WheelPicker
                    dateItems={dateItems}
                    dateValue={date}
                    onDateChange={setDate}
                    hourItems={hourItems}
                    hourValue={hour}
                    onHourChange={setHour}
                    minuteItems={minuteItems}
                    minuteValue={minute}
                    onMinuteChange={setMinute}
                    ampmItems={ampmItems}
                    ampmValue={ampm}
                    onAmpmChange={setAmpm}
                />
            </div>
            <div className="milestone-step-actions px-3">
                <button onClick={() => submitDeadline()} className="theme-btn theme-btn-primary w-100">Submit</button>
            </div>
        </div>
    )
}


const DeadlineCalendarModal: React.FC<DeadlineCalendarProps> = (props) => {
    const title = `Add Deadline`

    const ModalComponent = useMemo(() => inModal(DeadlineCalendar, title), [title])
    return <ModalComponent {...props} />
}


export default DeadlineCalendarModal;